import { useFileRecords } from '../../../queries/use-file-records';
import { Worksheet } from '../../../types/worksheet';
import PreviewSection from '../PreviewSection';
import FilePreview from './FilePreview';

type FilesPreviewProps = {
    worksheet: Worksheet;
};
function FilesPreview({ worksheet }: FilesPreviewProps): JSX.Element {
    const filesQuery = useFileRecords(1, 999, worksheet.id, worksheet.id, '', '', '');

    if (filesQuery.isLoading || filesQuery.isError) {
        return <></>;
    }

    const records = filesQuery.data?.data?.records ?? [];

    return (
        <PreviewSection title={`Files (${worksheet.files.length})`}>
            {records.length > 0 && (
                <div className="mt-2">
                    <div className="grid grid-cols-3">
                        <p className="col-span-2 text-gray-600 text-sm font-medium border-b pb-2">Name</p>
                        <p className="text-gray-600 text-sm font-medium border-b pb-2">Updated</p>
                        {records.map((r) => {
                            return <FilePreview record={r} key={r.id} />;
                        })}
                    </div>
                </div>
            )}
        </PreviewSection>
    );
}

export default FilesPreview;
